import { render } from "./ProductTable.vue?vue&type=template&id=71fb7d9b&scoped=true"
import script from "./ProductTable.vue?vue&type=script&lang=js"
export * from "./ProductTable.vue?vue&type=script&lang=js"

import "./ProductTable.vue?vue&type=style&index=0&id=71fb7d9b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71fb7d9b"

export default script